<template lang="pug">
    div(:class="html? 'hzTooltips' : ''", :html="html", :direct="direct", :reverse="reverse", :data-width="maxWidth")
        slot {{subHtml}}
</template>

<script>
    export default {
        name: 'hz-tooltips',
        props: {
            html: String,
            direct: { type: String, default: 'top' },
            reverse: { type: Boolean, default: false},
            maxWidth: { type: String, default: '500px' },
            limited: { type: Number, default: null }
        },

        data() {
            return {
                _timer: null
            }
        },

        computed: {
            subHtml() {
                if(!this.limited) {
                    return this.html;
                }
                if(!this.html || this.html.length <= this.limited) {
                    return this.html;
                }

                return this.html.slice(0, this.limited) + '...';
            }
        },
        
        data: function() {
            return {
                isShow: false
            }
        },

        methods: {
            mouseover(e) {
                if(!this.html) {
                    return;
                } 
                this._timer && clearTimeout(this._timer);
                this.isShow = true;
                this.$nextTick( e => {
                    if(this.$refs.inner.clientWidth > parseInt(this.maxWidth)) {
                        this.$refs.inner.style.width = this.maxWidth;
                        this.$refs.inner.style.whiteSpace = 'normal';
                    }
                })
            },

            mouseout(e) {
                if(!this.html) {
                    return;
                } 
                this._timer = setTimeout(e => {
                    this.isShow = false;
                }, 10)
                
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/tooltips.vue